import { logger } from "../../../utils/logger.es.js";
import { timeCalculation } from "../timeOnPage/timeOnPage.es.js";
import { timeExpiredCheck } from "./utils.es.js";
import { URL_VISIT_IDS, EH_VISIT_ID, EH_VISIT_TS } from "./constants.es.js";
import "../../../v4-88c20f3b.js";
const updateVisitCookiesArray = (visitId, cookies, cookieHandler, cookieOptions) => {
  const urlVisitIdsArr = cookies[URL_VISIT_IDS] ? JSON.parse(cookies[URL_VISIT_IDS]) : [];
  urlVisitIdsArr.unshift(visitId);
  const currentTime = /* @__PURE__ */ new Date();
  cookieHandler.setCookie(
    {
      [EH_VISIT_ID]: visitId,
      [EH_VISIT_TS]: currentTime.toString(),
      [URL_VISIT_IDS]: JSON.stringify(urlVisitIdsArr)
    },
    [cookieOptions, cookieOptions, cookieOptions]
  );
};
const handleExistingUrlVisitId = (cookies, urlVisitId, urlVisitIdTs, cookieOptions, cookieHandler) => {
  const currentTime = /* @__PURE__ */ new Date();
  const ehVisitIdSetTime = urlVisitIdTs ? new Date(Number(urlVisitIdTs)) : currentTime;
  const timeDifference = timeCalculation(currentTime, ehVisitIdSetTime);
  if (urlVisitId === cookies[URL_VISIT_IDS][0]) {
    const visitId = timeExpiredCheck(timeDifference, urlVisitId, cookieOptions, cookieHandler);
    updateVisitCookiesArray(visitId, cookies, cookieHandler, cookieOptions);
    return visitId;
  } else {
    let visitId = cookies[EH_VISIT_ID];
    visitId = timeExpiredCheck(timeDifference, visitId, cookieOptions, cookieHandler);
    updateVisitCookiesArray(visitId, cookies, cookieHandler, cookieOptions);
    return visitId;
  }
};
const handleNewUrlVisitId = (cookies, urlVisitId, urlVisitIdTs, cookieOptions, cookieHandler) => {
  const currentTime = /* @__PURE__ */ new Date();
  const ehVisitIdSetTime = urlVisitIdTs ? new Date(Number(urlVisitIdTs)) : currentTime;
  const timeDifference = timeCalculation(currentTime, ehVisitIdSetTime);
  const visitId = timeExpiredCheck(timeDifference, urlVisitId, cookieOptions, cookieHandler);
  updateVisitCookiesArray(visitId, cookies, cookieHandler, cookieOptions);
  return visitId;
};
const processUrlVisitId = (cookies, urlVisitId, cookieOptions, cookieHandler, urlVisitIdTs) => {
  try {
    const urlVisitIdsArr = cookies[URL_VISIT_IDS] ? JSON.parse(cookies[URL_VISIT_IDS]) : [];
    if (urlVisitIdsArr.includes(urlVisitId)) {
      return handleExistingUrlVisitId(cookies, urlVisitId, urlVisitIdTs, cookieOptions, cookieHandler);
    } else {
      return handleNewUrlVisitId(cookies, urlVisitId, urlVisitIdTs, cookieOptions, cookieHandler);
    }
  } catch (error) {
    logger.error(`Error parsing URL Parameter ${error}`);
    return null;
  }
};
export {
  processUrlVisitId
};
